import { Box, Stack } from "@mui/joy";
import { Outlet } from "@tanstack/react-router";
import { Panel, PanelGroup } from "react-resizable-panels";

import { useCompetitionQuery, useCurrentCompetitionUuid } from "@/hooks/competitions";
import { StyledPanelResizeHandleVertical } from "@/routing/gym.$venueUuid/routes/$climbType";

import { useCompetitionContext } from "../CompetitionOverview/CompetitionProvider";
import { PillsSelect } from "../forms/PillsSelect";
import CompetitionRoutesMaps from "./CompetitionRoutesMaps";
import CompetitionRoutesTable from "./CompetitionRoutesTable";

export const CategorySelect = () => {
  const competitionUuid = useCurrentCompetitionUuid();
  const { data: competition } = useCompetitionQuery(competitionUuid);

  const { selectedCategoryUuid, setSelectedCategoryUuid } = useCompetitionContext();

  return (
    <PillsSelect
      value={selectedCategoryUuid || "ALL"}
      onChange={(value) => value && setSelectedCategoryUuid(value === "ALL" ? null : value)}
      options={[
        {
          name: "All",
          value: "ALL",
        },
        ...(competition?.stages[0].categories || []).map((category) => ({
          name: category.name,
          value: category.uuid,
        })),
      ]}
    />
  );
};

export default function CompetitionRoutes() {
  const competitionUuid = useCurrentCompetitionUuid();
  const { data: competition } = useCompetitionQuery(competitionUuid);

  return (
    <Stack direction="row" sx={{ height: "100%", minWidth: 0, flex: 1 }}>
      <PanelGroup
        direction="vertical"
        style={{ height: "100%", minWidth: 0, flex: 1, overflow: "hidden" }}
      >
        <Panel>
          <Box sx={{ height: "100%" }}>
            <CompetitionRoutesMaps />
          </Box>
        </Panel>
        <StyledPanelResizeHandleVertical />
        <Panel style={{ display: "flex", flexDirection: "column" }}>
          {competition?.stages[0].categories.length === 1 ||
          competition?.routeGroups.length === 1 ? null : (
            <Box sx={{ padding: 1 }}>
              <CategorySelect />
            </Box>
          )}
          <CompetitionRoutesTable />
        </Panel>
      </PanelGroup>
      {/* </Box> */}
      <Outlet />
    </Stack>
  );
}
